"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MountReactComponent_1 = __importDefault(require("@CommonFrontend/MountReactComponent/MountReactComponent"));
var react_1 = __importDefault(require("react"));
var ReactEditorActions_1 = require("./ReactEditorActions");
var _a = require("Common/Utils/ImageImports"), Save = _a.Save, ColorWheel = _a.ColorWheel, Settings = _a.Settings;
function default_1(settings, make, toggleCurrentTab, telemetry, access, createUi) {
    var saveBlock = make(require("./SaveBlock/SaveBlock"));
    var styleSelector = make(require("./StyleSelector/StyleSelector"));
    var settingsPanel = make(require("./Settings/Settings"), { settingItems: settings });
    return [
        {
            name: "Settings",
            internal: "settings",
            displayType: "complex",
            description: "Settings for this block",
            event: "Clicked on block settings",
            icon: Settings,
            ui: settingsPanel.ui,
            ctrl: settingsPanel,
            enabled: true,
            onClick: function (item) {
                telemetry.trackOnly("Block Settings Viewed");
                return toggleCurrentTab(item);
            },
        },
        {
            name: "Block Styles",
            internal: "styles",
            displayType: "complex",
            description: "Change the style of this block",
            event: "Clicked on change styles",
            icon: ColorWheel,
            ui: styleSelector.ui,
            ctrl: styleSelector,
            enabled: access !== "view",
            onClick: function (item) {
                telemetry.trackOnly("Block Styles Viewed");
                return toggleCurrentTab(item);
            },
        },
        {
            name: "Add to library",
            internal: "save",
            displayType: "complex",
            description: "Save this content for later",
            event: "Clicked on save block",
            icon: Save,
            reactIcon: (0, MountReactComponent_1.default)(createUi)(react_1.default.createElement(ReactEditorActions_1.SaveBlockIcon)),
            ui: saveBlock.ui,
            ctrl: saveBlock,
            enabled: access !== "view",
            onClick: toggleCurrentTab,
        },
    ];
}
exports.default = default_1;
